import { createSelector } from 'reselect';

export const getUser = state => {
    if (state.auth.get('user') && state.auth.getIn(['user', 'data'])) {
        return state.auth.getIn(['user', 'data']);
    }
    return undefined;
};

const getKeycloakUser = state => {
    if (state.auth.get('user') && state.auth.getIn(['user', 'keycloakData'])) {
        return state.auth.getIn(['user', 'keycloakData']);
    }
    return undefined;
};

const getAuthenticatedState = state => state.auth.get('isAuthorized');
const getEditModalShown = state => state.auth.getIn(['editModal', 'isShown']);
const getChangePasswordModalShown = state => state.auth.getIn(['changePasswordModal', 'isShown']);

const getChangePasswordModalHasError = state => state.auth.getIn(['changePasswordModal', 'hasError']);
const getChangePasswordModalErrorText = state => state.auth.getIn(['changePasswordModal', 'errorText']);

/* ====================== SELECTORS ======================== */

export const getUserData = createSelector([getUser], user => user);

export const getKeycloakUserData = createSelector([getKeycloakUser], user => user);

export const getUserName = createSelector([getUser], userData => {
    if (userData) {
        return userData.get('name');
    }
});

export const getUserSurName = createSelector([getUser], userData => {
    if (userData) {
        return userData.get('surename');
    }
});

export const getUserEmail = createSelector([getUser], userData => {
    if (userData) {
        return userData.get('email');
    }
});

export const getUserCompany = createSelector([getUser], userData => {
    if (userData) {
        return userData.get('company');
    }
});

export const getUserId = createSelector([getUser], userData => {
    if (userData) {
        return userData.get('id');
    }
    return undefined;
});

export const getUserEditModalIsShown = createSelector([getEditModalShown], isShown => isShown);

export const getUserChangePasswordModalIsShown = createSelector([getChangePasswordModalShown], isShown => isShown);

export const getUserChangePasswordHasError = createSelector([getChangePasswordModalHasError], hasError => hasError);
export const getUserChangePasswordErrorText = createSelector([getChangePasswordModalErrorText], errorText => errorText);

export const isRoleAdministrator = createSelector(
    [getUser],
    userData => userData && userData.get('admin') === true
);

export const isRoleTester = createSelector(
    [getUser],
    userData => userData && userData.get('tester') === true
);

export const isRoleInstaller = createSelector(
    [getUser],
    userData => userData && userData.get('installer') === true
);

export const getIsAuthenticated = createSelector(
    [getAuthenticatedState],
    isAuthenticated => isAuthenticated
);
